module.exports = __webpack_public_path__ + "img/add_btn_icon220.5e618ff8.svg";